// Schriften selbst gehostet (keine CDNs): Source Sans 3 für die Oberfläche,
// Fraunces 600/700 für Überschriften und die Wortmarke.
import '@fontsource-variable/source-sans-3'
import '@fontsource/fraunces/600.css'
import '@fontsource/fraunces/700.css'
import 'primeicons/primeicons.css'
import '@/style.css'
import '@/theme/print.css'

import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import { createApp } from 'vue'

import App from '@/App.vue'
import router from '@/router'
import { de } from '@/strings/de'
import { SelwaPreset } from '@/theme/preset'

/** Deutsche Beschriftungen der PrimeVue-Komponenten. */
const deLocale = {
  accept: de.common.yes,
  reject: de.common.no,
  cancel: de.actions.cancel,
  clear: de.patient.filter.reset,
  choose: 'Auswählen',
  upload: 'Hochladen',
  emptyMessage: de.common.empty,
  emptySearchMessage: de.patients.emptySearch,
  emptySelectionMessage: 'Kein Eintrag ausgewählt',
  emptyFilterMessage: de.patients.emptySearch,
  searchMessage: 'Suche …',
  dateFormat: 'dd.mm.yy',
  firstDayOfWeek: 1,
  today: 'Heute',
  weekHeader: 'KW',
  dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
  dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  monthNames: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  aria: {
    close: de.actions.close,
    previous: 'Zurück',
    next: 'Weiter',
    navigation: de.nav.menuTitle,
  },
}

const queryOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 30 * 1000,
      },
    },
  },
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(VueQueryPlugin, queryOptions)
app.use(PrimeVue, {
  theme: {
    preset: SelwaPreset,
    options: {
      // Nur Light-Theme.
      darkModeSelector: 'none',
      cssLayer: { name: 'primevue', order: 'theme, base, primevue' },
    },
  },
  locale: deLocale,
})
app.use(ToastService)
// Für `<ConfirmDialog>` (Löschbestätigung Patientenliste, Verwaltung).
app.use(ConfirmationService)

app.mount('#app')
